/* iter v33 r24 · User M1500 — Banner "AI foto lenta al momento"
 *
 * Mostrato in Home + PropertyDetail quando /api/app/ai-health ritorna
 * status "slow" o "degraded". Cosi' l'utente sa che aspettare qualche
 * minuto non e' l'app rotta, e' Nano Banana sotto stress.
 *
 * Fetch discreto ogni 60s. Nessun render se healthy.
 */

import React, { useEffect, useState } from "react";
import { Warning, Sparkle } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export default function AIHealthBanner({ compact = false }) {
  const [state, setState] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/app/ai-health");
        if (alive) setState(data);
      } catch { /* silent */ }
    };
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!state || state.status === "healthy") return null;

  const isDegraded = state.status === "degraded";
  const label = isDegraded
    ? "AI foto momentaneamente giu' · riprova tra qualche minuto"
    : "AI foto lenta al momento · alcune foto potrebbero impiegare piu' del solito";

  if (compact) {
    return (
      <div
        className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10.5px] font-semibold ${
          isDegraded
            ? "bg-[#FBE5D6] text-[#8B4513] border border-[#E8A87C]"
            : "bg-[#FBF3E0] text-[#8A7745] border border-[#C9B27A]"
        }`}
        data-testid="ai-health-badge"
      >
        {isDegraded ? <Warning size={10} weight="fill" /> : <Sparkle size={10} weight="fill" />}
        {isDegraded ? "AI giu'" : "AI lenta"}
      </div>
    );
  }

  return (
    <div
      className={`rounded-lg border px-3 py-2 flex items-start gap-2 ${
        isDegraded
          ? "bg-[#FBE5D6] border-[#E8A87C] text-[#7A3A0B]"
          : "bg-[#FBF3E0] border-[#C9B27A] text-[#5A4520]"
      }`}
      data-testid="ai-health-banner"
    >
      {isDegraded ? (
        <Warning size={16} weight="fill" className="shrink-0 mt-0.5" />
      ) : (
        <Sparkle size={16} weight="fill" className="shrink-0 mt-0.5" />
      )}
      <div className="text-[11.5px] leading-tight">{label}</div>
    </div>
  );
}
